/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_ZipCodeLookUp_CityStateLookupDTO } from '../models/Wealthlane_CustomerService_Dtos_ZipCodeLookUp_CityStateLookupDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ZipCodeLookUpService {

    /**
     * @param zipCode
     * @returns Wealthlane_CustomerService_Dtos_ZipCodeLookUp_CityStateLookupDTO OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppZipCodeLookUpZipCodeLookUp(
        zipCode?: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ZipCodeLookUp_CityStateLookupDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/zip-code-look-up/zip-code-look-up',
            query: {
                'zipCode': zipCode,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param zipCodes
     * @returns Wealthlane_CustomerService_Dtos_ZipCodeLookUp_CityStateLookupDTO OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppZipCodeLookUpZipCodeLookUpList(
        zipCodes?: Array<string>,
    ): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ZipCodeLookUp_CityStateLookupDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/zip-code-look-up/zip-code-look-up-list',
            query: {
                'zipCodes': zipCodes,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
